<pannel [title]="'Consignes & mesures en cas de situation anormale / urgence'" [expandable]="true">
	<div *ngIf="traductionsSituationAnormal">
		<h4><b>Obligations pour l’EE</b></h4>
		<ul class="consignes-urgence">
			<li *ngFor="let trad of traductionsSituationAnormal"
			    [class.triangle]="trad.presentation === 'TRIANGLE'"
			    [class.no-bullet]="trad.presentation === 'TAB'">
			    <ng-container *ngIf="trad.presentation === 'TRIANGLE'">
			        {{ trad.fr }}
			    </ng-container>
			    <ng-container *ngIf="trad.presentation === 'TAB'">
			        <div class="tabbed">{{ trad.fr }}</div>
			    </ng-container>
			</li>
		</ul>
	</div>
</pannel>

<pannel [title]="'Consignes & mesures générales de sécurité de EU'" [expandable]="true"> 

	<div *ngIf="traductionsObligations">
		<h4><b>Obligations pour l’EE :</b></h4>
		<ul>
			<li *ngFor="let trad of traductionsObligations">
		        <ng-container *ngIf="trad.presentation === 'TICK'">
		            {{ trad.fr }}
		        </ng-container>
			</li>
		</ul>
	</div>
	
	<div>
		<h4><b>Risques liés au travail isolé (ou travailde nuit si concerné) :</b></h4>
		<ul>
			<li *ngFor="let trad of traductionsRisquesTrav">
		        <ng-container *ngIf="trad.presentation === 'TICK'">
		            {{ trad.fr }}
		        </ng-container>
			</li>
		</ul>
	</div>
</pannel>


<document-pa-step-actions [documentPaButtons]="actionButtons" (onButtonPressed)="performAction($event)"></document-pa-step-actions>
